import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'ServiceMonitorService',
    controller: 'ServiceConfig'
};

const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'DelItemList',
    'GeItemById',
    'FindByConditions',
    'GetItemPagingList'  
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const TranResourcesApi = ZJApi.defineNewApi('TranResourcesApi', factory);

export default TranResourcesApi;